module.exports = __webpack_public_path__ + "static/media/PersoVert.e6c4db47.png";